import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ITela} from "../../objeto/ITela";
import {CarrinhoService} from "../../services/carrinho.service";
import {PedidosService} from "../../services/pedidos.service";
import {ActivatedRoute} from "@angular/router";
import {timer} from "rxjs";
import {DominiosService} from "../../services/dominios.service";
import {EnumMeioDePagamento} from "../../objeto/EnumMeioDePagamento";
import {DialogCloseResult, DialogService} from "@progress/kendo-angular-dialog";
import {TelaCartaoDeCreditoComponent} from "../tela-cartao-de-credito/tela-cartao-de-credito.component";
import {DadosCartao} from "../../objeto/DadosCartao";
import moment from "moment";
import {MyDetectorDevice} from "../shared/MyDetectorDevice";
import {AvaliacaoService} from "../../services/avaliacao.service";
import {ThreeDSDialogComponent} from "./three-ds-dialog";
import {PagamentoPixQrcodeComponent} from "./pagamento-pix/pagamento-pix-qrcode.component";
import {TunapayService} from "../../services/tunapay.service";
import {
  PagamentoonlinePedidoRetentativaComponent
} from "./pagamentoonline-pedido-retentativa/pagamentoonline-pedido-retentativa.component";
import {TunapayGlobalComponent} from "../../loja-pagamento/tunapay-global.component";
import {GetnetService} from "../../services/getnet.service";

declare var fbq;
@Component({
  selector: 'app-tela-acompanhar-pedido',
  templateUrl: './tela-acompanhar-pedido.component.html',
  styleUrls: ['./tela-acompanhar-pedido.component.scss']
})
export class TelaAcompanharPedidoComponent implements OnInit, ITela , OnDestroy {
  @ViewChild('telaPix', { static: false} ) telaPix: PagamentoPixQrcodeComponent;
  pedido: any = {};
  pagamento: any;
  empresa: any = {};
  cancelando: boolean;
  guid: string;
  timerPedidos;
  carregou: boolean;
  FormaDeEntrega = FormaDeEntrega;
  urlArir;
  acabouFazerPedido = false;
  EnumMeioDePagamento = EnumMeioDePagamento;
  falhaNoPagamentoOnline: boolean;
  autenticarPagamento: boolean;
  mensagemFalhaPagamento: string;
  dadosCartao: DadosCartao;
  telaPagamento: any;
  foiPago: boolean;
  foiReembolsado: boolean;
  tentandoNovoPagamento: boolean;
  textoHorarioEntregaAgendada: any;
  titulo = 'Detalhes do pedido';

  desktop = false;
  avaliacao: any = {};
  msg = '';
  dialogRefAutenticar: any;
  aguardandoTokenizar: boolean;
  buscandoPedido: boolean;
  retorno3ds: string;
  urlRedirect: string
  isMobile: boolean;
  pagamentoOnlineLoja: boolean;
  pedidoCarteirasDigitais: any;
  formaPagamentoCarteirasDigitais: any;
  dialogRefPagamentoRetentativa: any;
  abriuPagamentoOnlineLojaAutomatico = false;
  abriuGetnetNoCarregamento = false;
  constructor(private carrinhoService: CarrinhoService, public  dominiosService: DominiosService,
              private activatedRoute: ActivatedRoute, private pedidosService: PedidosService,
              private dialogService: DialogService , private tunapayService: TunapayService,
              private detectorDevice: MyDetectorDevice, private avaliacaoService: AvaliacaoService,
              private getnetService: GetnetService) { }

  ngOnInit(): void {
    let state = window.history.state;

    this.falhaNoPagamentoOnline = state.falhaNoPagamentoOnline
    this.mensagemFalhaPagamento = state.mensagemFalhaPagamento
    this.apliqueFallbackExigirCvv(state);

    if(state.aguardandoTokenizar) this.aguardandoTokenizar  = true;

    this.desktop = this.detectorDevice.isDesktop();
    this.guid =  this.activatedRoute.snapshot.params.guid;
    this.msg = this.activatedRoute.snapshot.queryParams.msg;
    this.pagamentoOnlineLoja = this.activatedRoute.snapshot.queryParams.pgonline === 'loja';

    if(state && state.pedido){
      this.urlArir = state.urlArir;
      this.empresa = state.empresa;
      this.pedido = state.pedido;
      this.falhaNoPagamentoOnline = state.falhaNoPagamentoOnline
      this.mensagemFalhaPagamento = state.mensagemFalhaPagamento
      this.apliqueFallbackExigirCvv(state);

      this.acabouFazerPedido = true;
    } else {
      let dados: any = this.carrinhoService.obtenhaDadosUltimoPedido();

      if (dados && dados.pedido.guid === this.guid) {
        this.urlArir = dados.urlAbrir;
        this.empresa = dados.empresa;
        this.pedido = dados.pedido;
        if(this.pedido.horarioEntregaAgendada)
          this.textoHorarioEntregaAgendada =
            moment(this.pedido.horarioEntregaAgendada).utcOffset("-0400").format("DD/MM/YYYY [às] HH:mm:ss")

        this.falhaNoPagamentoOnline = dados.falhaNoPagamentoOnline
        this.mensagemFalhaPagamento = dados.mensagemFalhaPagamento
        this.apliqueFallbackExigirCvv(dados);
        this.acabouFazerPedido = true;
      }
      if(! this.guid && this.pedido)  this.guid = this.pedido.guid;
    }

    if(this.activatedRoute.snapshot.params.status3ds){
      this.retorno3ds = this.activatedRoute.snapshot.params.status3ds; // error or success
      if( this.retorno3ds  !== 'success'){
        this.falhaNoPagamentoOnline = true;
        this.mensagemFalhaPagamento = this.activatedRoute.snapshot.queryParams.autherr || 'Autenticação falhou';
      }
    }

    this.inicieMonitoramentoPedido();
    this.isMobile = this.detectorDevice.isMobile();
  }


  private inicieMonitoramentoPedido() {
    const trintaSegundos = 1000 * 30;
    const cicoSegundos = 1000 * 5;
    const tempomonitoramento = this.retorno3ds ? cicoSegundos : trintaSegundos;

    this.timerPedidos =  timer(0, tempomonitoramento  ).subscribe( () => {
       this.obtenhaPedidosAtualizado()
    });

  }

  private obtenhaPedidosAtualizado(cb: any = null) {
    if(this.tentandoNovoPagamento || this.buscandoPedido) return;

    this.buscandoPedido = true;
    this.pedidosService.monitorePagamentoOnline(this.guid).then( (resultado: any) => {
      this.buscandoPedido = false;
      let pedido = resultado.pedido

      this.carregou = true;
      this.pedido = pedido || {};
      this.pagamento = resultado.pagamento || {};
      this.avaliacao = resultado.avaliacao;
      this.preparePagamentoCarteirasDigitais();


      if(this.telaPix)
        this.telaPix.atualizouPagamento(this.pedido, this.pagamento)

      if(pedido.aguardandoTokenizar != null)
        this.aguardandoTokenizar = pedido.aguardandoTokenizar ;


      if(this.pagamento.formaDePagamento && this.pagamento.formaDePagamento.pix )
        this.titulo = `Pague R$ ${pedido.total.toFixed(2).replace('.', ',')} via PIX.`

      if(pedido.pago){
        let pedidoLocal = this.carrinhoService.obtenhaPedido();
        if(pedidoLocal.guid === this.guid)
          this.carrinhoService.limpePedido();
        this.foiPago = true;
        this.aguardandoTokenizar = false;
      }
      else
        this.foiPago = false

      this.falhaNoPagamentoOnline =  this.pagamento.falhaNoPagamentoOnline
      this.mensagemFalhaPagamento =  this.pagamento.mensagemFalhaPagamento
      this.foiReembolsado =  this.pagamento.foiReembolsado

      this.tenteAbrirGetnetPendente();

      if(this.pagamento.urlAutenticar && !this.retorno3ds){
        this.aguardandoTokenizar = false;
        this.autenticarPagamento = true;
        this.open3DSDialog(this.pagamento.urlAutenticar);
      }

      if(pedido.finalizado)
        this.pareMonitoramento();

      if(this.pedido.horarioEntregaAgendada) {

        this.textoHorarioEntregaAgendada = moment(this.pedido.horarioEntregaAgendada)
          .utcOffset("-0" + (this.empresa.fusoHorario * -1) + "00").format("DD/MM/YYYY [às] HH:mm:ss")
      }

      this.abraPagamentoOnlineLojaAutomatico();

      if(cb)   cb();
    }).catch((err) => {
      this.buscandoPedido = false;
    })
  }

  tenteAbrirGetnetPendente(){
    if(this.abriuGetnetNoCarregamento || !this.ehPagamentoGetnet() || !this.pagamento?.getnetRedirectUrl || this.foiPago)
      return;

    this.abriuGetnetNoCarregamento = true;
    this.getnetService.abrirLightbox(this.pagamento.getnetRedirectUrl);
  }

  ngOnDestroy(){
   this.pareMonitoramento()
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu() {
    return true;
  }

  deveExibirPainelPedidoFinalizado(): boolean {
    return !!(this.pedido
      && !this.pedido.cancelado
      && (this.acabouFazerPedido || this.deveExibirPagamentoOnlinePendente()));
  }

  deveExibirPagamentoOnlinePendente(): boolean {
    return !!(this.pedido
      && this.pedido.aguardandoPagamentoOnline
      && !this.pedido.pago
      && !this.pedido.cancelado);
  }

  cancelePedidoAguardando() {
    this.cancelando = true;

    this.pedidosService.cancelePedido(this.pedido).then( (resposta) => {
      this.cancelando = false;
      this.pedido = resposta;
      this.carrinhoService.limpePedido();

    }).catch((erro: any) => {
      this.cancelando = false;
      alert(erro)
    })
  }


  private pareMonitoramento() {
    if(this.timerPedidos)
      this.timerPedidos.unsubscribe();
  }

  gerePix(){
    this.tentandoNovoPagamento = true;

    this.pedidosService.tentePagamentoPix({codigo: this.pedido.codigo}).then((resposta: any) => {
      this.tentandoNovoPagamento = false;
      if(!resposta.falhaNoPagamentoOnline) {
        this.obtenhaPedidosAtualizado(() => { })
      } else  {
        this.falhaNoPagamentoOnline =  resposta.falhaNoPagamentoOnline
        this.mensagemFalhaPagamento = resposta.mensagemFalhaPagamento
      }
    }).catch( erro => {
      this.tentandoNovoPagamento = false;
      this.falhaNoPagamentoOnline = true;
      this.mensagemFalhaPagamento = erro;
    })
  }

  open3DSDialog(url3DS: string): void {
    if( this.dialogRefAutenticar) return;

    let dados: any = {
         title: 'Autenticação 3D Secure Cartão',
        content: ThreeDSDialogComponent,
        width: 600,
        height: 300
    }

    if( window.innerWidth < 800 )
      dados.width = '95%';

    this.dialogRefAutenticar = this.dialogService.open(dados);

    // Set the URL in the dialog component instance
    const dialogInstance =  this.dialogRefAutenticar.content.instance as ThreeDSDialogComponent;

    dialogInstance.setUrl(url3DS)

    this.dialogRefAutenticar.result.subscribe((result: any) => {
      this.dialogRefAutenticar = null
      if(result && result.retornou)
        this.obtenhaPedidosAtualizado()
    })
  }

  obtenhaLabelBotaoCartao(): string {
    if(this.pagamentoOnlineLoja && !this.falhaNoPagamentoOnline)
      return this.tentandoNovoPagamento ? 'Aguarde enquanto processamos seu pagamento...' : 'Pagar agora no cartão';

    return this.tentandoNovoPagamento ? 'Aguarde enquanto enviamos seu novo pagamento...' : 'Tentar novo pagamento';
  }

  private preparePagamentoCarteirasDigitais(){
    this.formaPagamentoCarteirasDigitais = this.pagamento?.formaDePagamentoCarteirasDigitais
      || this.crieFallbackFormaCarteirasDigitais();

    if(!this.pedido?.novaTentativaCarteiraDigitais || !this.formaPagamentoCarteirasDigitais){
      this.pedidoCarteirasDigitais = null;
      return;
    }

    const pedido = this.pedido;
    const pagamento = {
      formaDePagamento: null,
      dadosCartao: null,
      processando: false
    };

    this.pedidoCarteirasDigitais = {
      ...pedido,
      pagamento,
      calculeTotal: () => {},
      obtenhaValorAhPagar: () => Number(this.pagamento?.valor || pedido.total || 0)
    };
  }

  private crieFallbackFormaCarteirasDigitais(): any {
    const forma = this.pagamento?.formaDePagamento;
    if(!forma || !forma.exibirCardapio || forma.pix || !forma.carteirasDigitais) return null;

    return {
      ...forma,
      carteirasDigitais: true,
      pix: false,
      descricao: 'Carteiras Digitais',
      nome: 'Carteiras Digitais'
    };
  }

  private abraPagamentoOnlineLojaAutomatico(){
    if(this.abriuPagamentoOnlineLojaAutomatico
      || !this.pagamentoOnlineLoja
      || !this.deveExibirPagamentoOnlinePendente()
      || !this.temPagamentoRetentativaDisponivel())
      return;

    this.abriuPagamentoOnlineLojaAutomatico = true;
    setTimeout(() => this.abraModalPagamentoRetentativa(), 0);
  }

  temPagamentoRetentativaDisponivel(): boolean {
    return this.temCartaoRetentativaDisponivel()
      || this.temCarteiraDigitalRetentativaDisponivel()
      || this.temPixRetentativaDisponivel();
  }

  private temCartaoRetentativaDisponivel(): boolean {
    const formaCartao = this.pagamento?.formaDePagamentoCartao || this.pagamento?.formaDePagamento;

    return !!(this.pedido?.novaTentativaCartao
      && formaCartao
      && formaCartao.exibirCardapio
      && !formaCartao.pix
      && !formaCartao.carteirasDigitais);
  }

  private temCarteiraDigitalRetentativaDisponivel(): boolean {
    return !!(this.pedido?.novaTentativaCarteiraDigitais
      && this.formaPagamentoCarteirasDigitais
      && this.formaPagamentoCarteirasDigitais.exibirCardapio
      && this.pedidoCarteirasDigitais);
  }

  private temPixRetentativaDisponivel(): boolean {
    const formaPix = this.pagamento?.formaDePagamentoPix;

    return !!(this.pedido?.novaTentativaPix
      && formaPix
      && formaPix.exibirCardapio
      && formaPix.pix);
  }

  abraModalPagamentoRetentativa(){
    if(!this.temCarteiraDigitalRetentativaDisponivel()){
      if(this.temCartaoRetentativaDisponivel()){
        this.abrirPopupNovoPagamento();
        return;
      }

      if(this.temPixRetentativaDisponivel()){
        this.gerePix();
        return;
      }
    }

    if(this.dialogRefPagamentoRetentativa) return;

    const dialogRef = this.dialogService.open({
      title: null,
      content: PagamentoonlinePedidoRetentativaComponent,
      width: this.isMobile ? '100%' : 760,
      maxWidth: '95%',
      cssClass: 'dialog-retentativa-pagamento'
    });

    this.dialogRefPagamentoRetentativa = dialogRef;
    const modal = dialogRef.content.instance as PagamentoonlinePedidoRetentativaComponent;
    modal.pedido = this.pedido;
    modal.pedidoCarteirasDigitais = this.pedidoCarteirasDigitais;
    modal.formaPagamentoCarteirasDigitais = this.formaPagamentoCarteirasDigitais;
    modal.exibirCartao = this.temCartaoRetentativaDisponivel();
    modal.exibirCarteirasDigitais = this.temCarteiraDigitalRetentativaDisponivel();
    modal.exibirPix = this.temPixRetentativaDisponivel();
    modal.processando = this.tentandoNovoPagamento;

    modal.escolheuCartao.subscribe(() => {
      dialogRef.close();
      this.abrirPopupNovoPagamento();
    });

    modal.escolheuPix.subscribe(() => {
      dialogRef.close();
      this.gerePix();
    });

    modal.definiuCarteiraDigital.subscribe((dadosCartao: any) => {
      this.pagueComCarteiraDigital(dadosCartao).then((processou: boolean) => {
        modal.processando = false;
        if(processou)
          dialogRef.close();
      });
    });

    dialogRef.result.subscribe(() => {
      this.dialogRefPagamentoRetentativa = null;
    });
  }

  pagueComCarteiraDigital(dadosCartao: any){
    if(!dadosCartao) return Promise.resolve(false);

    delete this.falhaNoPagamentoOnline;
    this.tentandoNovoPagamento = true;

    return this.pedidosService.tentePagamentoCartao({codigo: this.pedido.codigo
      , pagamentos: [{
        formaDePagamento: this.pagamento.formaDePagamento,
        dadosCartao: dadosCartao
      }]}).then((resposta: any) => {
      this.tentandoNovoPagamento = false;
      if(!resposta.falhaNoPagamentoOnline) {
        this.obtenhaPedidosAtualizado(() => { })
        return true;
      } else  {
        this.falhaNoPagamentoOnline =  resposta.falhaNoPagamentoOnline
        this.mensagemFalhaPagamento = resposta.mensagemFalhaPagamento
        return false;
      }
    }).catch( erroNovo => {
      this.tentandoNovoPagamento = false;
      this.falhaNoPagamentoOnline = true;
      this.mensagemFalhaPagamento = erroNovo;
      return false;
    })
  }

  abrirPopupNovoPagamento() {
    if(this.ehPagamentoGetnet() && !this.ehGetnetCheckoutPro()){
      this.tenteNovoPagamentoGetnet();
      return;
    }

    const windowRef = TelaCartaoDeCreditoComponent.abraComoPopup(this.dialogService, false, this.pedido, this.pagamento, this.dadosCartao);
    this.telaPagamento = windowRef.content.instance;

    windowRef.result.subscribe((result: any) => {
      if(result && (result instanceof DadosCartao)){
        delete this.falhaNoPagamentoOnline;
        delete this.retorno3ds;
        this.tentandoNovoPagamento = true;
        this.dadosCartao = (result as DadosCartao).outroSemDadosSensitivos();

        this.pedidosService.tentePagamentoCartao({codigo: this.pedido.codigo
          , pagamentos: [{
            formaDePagamento: this.pagamento.formaDePagamento ,
            dadosCartao:  this.dadosCartao
          }]}).then((resposta: any) => {
          this.tentandoNovoPagamento = false;
          if(!resposta.falhaNoPagamentoOnline) {
            this.obtenhaPedidosAtualizado(() => { })
          } else  {
            this.falhaNoPagamentoOnline =  resposta.falhaNoPagamentoOnline
            this.mensagemFalhaPagamento = resposta.mensagemFalhaPagamento
            this.apliqueFallbackExigirCvv(resposta);
          }
        }).catch( erro => {
          this.tentandoNovoPagamento = false;
          this.falhaNoPagamentoOnline = true;
          this.mensagemFalhaPagamento = erro;
        })
      }
    });

  }

  tenteNovoPagamentoGetnet(){
    delete this.falhaNoPagamentoOnline;
    delete this.retorno3ds;
    this.tentandoNovoPagamento = true;

    this.pedidosService.tentePagamentoCartao({codigo: this.pedido.codigo})
      .then((resposta: any) => {
        this.tentandoNovoPagamento = false;

        if(resposta.getnet && resposta.getnet.redirectUrl){
          this.getnetService.abrirLightbox(resposta.getnet.redirectUrl);
          this.obtenhaPedidosAtualizado(() => { });
          return;
        }

        if(resposta.falhaNoPagamentoOnline){
          this.falhaNoPagamentoOnline = resposta.falhaNoPagamentoOnline;
          this.mensagemFalhaPagamento = resposta.mensagemFalhaPagamento;
          return;
        }

        this.obtenhaPedidosAtualizado(() => { });
      }).catch(erro => {
        this.tentandoNovoPagamento = false;
        this.falhaNoPagamentoOnline = true;
        this.mensagemFalhaPagamento = erro;
      });
  }

  ehPagamentoGetnet(){
    return this.pagamento?.tipoOnline === EnumMeioDePagamento.Getnet ||
      this.pagamento?.formaDePagamento?.configMeioDePagamento?.meioDePagamento === EnumMeioDePagamento.Getnet ||
      this.pedido?.gatewayPagamentoOnline === EnumMeioDePagamento.Getnet;
  }

  ehGetnetCheckoutPro(){
    const config = this.pagamento?.formaDePagamento?.configMeioDePagamento ||
      this.pedido?.pagamento?.formaDePagamento?.configMeioDePagamento ||
      this.pedido?.pagamentos?.find((pagamento: any) =>
        pagamento?.formaDePagamento?.configMeioDePagamento?.meioDePagamento === EnumMeioDePagamento.Getnet
      )?.formaDePagamento?.configMeioDePagamento;

    return String(config?.tipoCheckoutGetnet || '').toLowerCase().trim() === 'checkoutpro';
  }

  private apliqueFallbackExigirCvv(resposta: any){
    if(!resposta || !resposta.exigirCvvCartaoSalvo)
      return;

    if(!this.dadosCartao){
      this.dadosCartao = new DadosCartao();
      if(this.pedido && this.pedido.pagamento && this.pedido.pagamento.dadosCartao){
        Object.assign(this.dadosCartao, this.pedido.pagamento.dadosCartao);
      }
    }

    this.dadosCartao.cartaoSalvoId = resposta.cartaoSalvoId || this.dadosCartao.cartaoSalvoId;
    (this.dadosCartao as any).exigirCvvCartaoSalvo = true;
    this.mensagemFalhaPagamento = 'Para continuar com o cartão salvo, informe o CVV e tente novamente.';
  }

  obtenhaDescricaoPromocoes() {
    return this.pedido.promocoesAplicadas.map((promocaoAplicada) => promocaoAplicada.promocao.descricao ).join(",")
  }

  deveTerBordas() {
    return true;
  }


  deveExibirBannerTema() {
    return false;
  }

}

export enum FormaDeEntrega {
  RECEBER_EM_CASA = 'Receber em casa',
  RETIRAR = 'Retirar'
}
